module.exports = __webpack_public_path__ + "img/HQ-PA10W1CH-T.74829bce.jpg";